import React from "react";

import { useShopQuery } from "@hooks/use-shop-query.js";
import { gql } from "graphql-request";

const queryProducts = gql`
query ProductAndCollection($country:CountryCode!, $collectionHandle:String!, $partnerProductHandle:String!) @inContext(country: $country){
		partnerProduct: product(handle:$partnerProductHandle){
		  	...CustomizerItem
		}
	  	compatibleCollection: collection(handle:$collectionHandle){
	    	products(first:100){
	      		edges{
	        		node{
			  			...CustomizerItem
					}
		  		}
	    	}
	  	}
	}

fragment CustomizerItem on Product {
	title,
	id,
	handle,
	available: availableForSale,
	description,
	title,
	type: productType,
	options{
		id,
		name,
		values
	}
	price: priceRange{
		maxVariantPrice {
			amount
		},
		minVariantPrice {
			amount
		}
	}
	image:featuredImage{
		url,
		altText
	}
	additionalOptions: metafield(namespace:"custom",key:"additional_product_options") {
		value
		references (first:100){
			edges {
				node {
					... on Metaobject {
						id,
						label: field(key:"label"){
							value
						}
						sublabel: field(key:"sublabel"){
							value
						}
						variant: field(key:"variant"){
							reference{
								... on ProductVariant{
									id
									compatibilityKeys: metafield(namespace:"compatibility",key:"keys") {
										value
									}
								}
							}
						}
						compatibility: field(key:"compatibility"){
							value
						}
					}
				}
			}
		}
	}
	variants(first:100){
		edges{
			node{
				id,
				title,
				sku,
				available: availableForSale,
				options: selectedOptions{
					name,
					value
				}
				price {
					amount
				}
				image {
					url,
					altText
				}
				compatibilityKeys: metafield(namespace:"compatibility",key:"keys") {
					value
				}
			}
		}
	}
}`

export const ProductCustomizerCollectionContext = React.createContext({
  loading: true
});

export const ProductCustomizerCollectionProvider = ({children, collectionHandle, partnerProductData, compatibilityKeys}) => {

	const partnerProductHandle = partnerProductData ? partnerProductData.split(":")[0] : "";
	const partnerVariantId = partnerProductData?.split(":")[1];
  	const variables = {collectionHandle, partnerProductHandle, country: Shopify.country }
  	const {data, loading, error} = useShopQuery(queryProducts, variables);

	let partnerProduct = null;
	if(data?.partnerProduct){
		const variants = data.partnerProduct.variants.filter(({id}) => {
    		return id.indexOf(partnerVariantId) > -1;
  		});
		partnerProduct = {
			...data.partnerProduct,
			variants
		}
	}

	const collection = data?.compatibleCollection?.products

  	return <ProductCustomizerCollectionContext.Provider value={{ loading, collection, partnerProduct, compatibilityKeys }}>
    	{children}
    </ProductCustomizerCollectionContext.Provider>;
}
